import { cn, useCopyToClipboard } from "@istari-frontend/shared";
import { Button } from "@istari-frontend/ui";
import { CheckIcon, CopyIcon } from "lucide-react";

interface CopyContentButtonProps {
  getText: () => string;
  disabled?: boolean;
  className?: string;
}

export function CopyContentButton({ getText, disabled, className }: CopyContentButtonProps) {
  const { copied, copy } = useCopyToClipboard({ timeout: 2000 });

  return (
    <Button
      variant="outline"
      size="xs"
      aria-live="polite"
      disabled={disabled}
      tooltip="Copy the file contents to your clipboard"
      onClick={() => copy(getText())}
      className={cn(
        "absolute top-2 right-4 z-20 backdrop-blur-sm",
        "opacity-0 transition-opacity duration-150 group-focus-within:opacity-100 group-hover:opacity-100",
        className,
      )}
    >
      <span className="relative size-3.5 shrink-0">
        <CopyIcon
          className={cn(
            "ease absolute inset-0 size-3.5 transition-[opacity,filter,transform] duration-200",
            copied ? "scale-98 opacity-0 blur-[2px]" : "scale-100 opacity-100 blur-none",
          )}
        />
        <CheckIcon
          className={cn(
            "absolute inset-0 size-3.5 text-green-600 transition-[opacity,filter,transform] duration-200 ease-out dark:text-green-400",
            copied ? "scale-100 opacity-100 blur-none delay-[20ms]" : "scale-98 opacity-0 blur-[2px]",
          )}
        />
      </span>
      {copied ? "Copied" : "Copy"}
    </Button>
  );
}
